<dx-box
    #conveyanceWidgetBox
    width="100%"
    height="100%"
    direction="col"
    [elementAttr]="{ id: 'conveyanceWidgetBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <app-conveyance-bar-chart
                *ngIf="!!conveyanceData && loadingCompleted"
                [palette]="currentPaletteName"
                [paletteMode]="currentPaletteMode"
                [chartData]="conveyanceData"
                [widgetMode]="true"
                [width]="chartWidth"
                [height]="chartHeight"
            ></app-conveyance-bar-chart>
        </div>
    </dxi-item>
</dx-box>

<dx-load-panel
    *ngIf="!loadingCompleted"
    [position]="{ of: !widgetId ? 'body' : '#conveyanceWidgetBox' + widgetId }"
    [visible]="!loadingCompleted"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>
